import request from 'utils/request'

export const getMCAXS491InitRequest = () =>
  request({
    url: '/MCAXS491/init',
    method: 'post',
  })
